import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { SkeletonCard } from '@components/ui';
import { publicRoutes } from './publicRoutes';
import { protectedRoutes } from './protectedRoutes';

// Lazy load pages for better performance
const NotFound = lazy(() => import('@pages/NotFound'));

// Loading fallback component
const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
    <div className="w-full max-w-4xl">
      <SkeletonCard />
    </div>
  </div>
);

export const AppRoutes = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {/* Protected Routes */}
        {protectedRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {/* Redirect root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

// Re-export route utilities for use throughout the app
export { publicRoutes } from './publicRoutes';
export { protectedRoutes } from './protectedRoutes';
export * from './routeConfig';
export type { AppRoute } from './types';
